import React from 'react';
import { IRootWidgetIdentifier } from '../../../tree/references';

interface IAllRootsContextValue {
  allRoots: IRootWidgetIdentifier[];
}

export const AllRootsContext = React.createContext<IAllRootsContextValue>({
  allRoots: [],
});

export interface IAllRootsContextProviderProps {
  allRoots: IRootWidgetIdentifier[];
  children: React.ReactNode;
}

export function AllRootsContextProvider(props: IAllRootsContextProviderProps) {
  const value = React.useMemo(
    () => ({ allRoots: props.allRoots }),
    [props.allRoots],
  );

  return (
    <AllRootsContext.Provider value={value}>
      {props.children}
    </AllRootsContext.Provider>
  );
}

export function useAllRootsContext() {
  const context = React.useContext(AllRootsContext);
  if (context == null) {
    throw new Error('useAllRootsContext must be used within an AllRootsContext'); // prettier-ignore
  }
  return context;
}
